import React from 'react';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import { toImgSrc } from '../../../../pages/CustomProgramPage/helpers';
import { ProfileFormValues } from './view-model/Profile.schema';
import * as styles from './MobilePreview.css';
import {
  ProfileSection,
  TabsSection,
  StringPreview,
  MobilePreview,
} from '@design-system/components/mobile-preview';

const defaultTabs = [
  { id: 1, label: 'Collections' },
  { id: 2, label: 'Extras' },
  { id: 3, label: 'Insights' },
  { id: 4, label: 'About' },
];

export const Preview = ({ profile }: { profile: ProfileFormValues }) => {
  const color = `#${profile.customColorSchema?.primaryColor ?? '000'}`;
  const bannerUrl = toImgSrc(profile.mediaBanner);

  return (
    <MobilePreview primaryColor={color} bannerImage={bannerUrl}>
      <ProfileSection profile={profile} primaryColor={color} />
      <TabsSection tabs={defaultTabs} activeTabId={4} primaryColor={color} />

      <section
        className={styles.section}
        style={assignInlineVars({
          [styles.colorVar]: color,
        })}
      >
        {profile.keywords?.length > 0 ? (
          <div className={styles.tagsContainer}>
            {profile.keywords.map((k) => (
              <span
                key={k}
                className={styles.tag}
                style={
                  {
                    '--color-var': color,
                  } as React.CSSProperties
                }
              >
                {k}
              </span>
            ))}
          </div>
        ) : (
          <span className={styles.empty}>Add tags</span>
        )}

        <div className={styles.contentSection}>
          <div className={styles.sectionTitle}>Story</div>
          <p className={`${styles.story} ${styles.textSm}`}>
            <StringPreview
              value={profile.messageProfile || ''}
              name="Story"
              maxLen={200}
            />
          </p>
        </div>

        <div className={styles.contentSection}>
          <div className={styles.sectionTitle}>Accomplishments</div>
          <p className={`${styles.accomplishments} ${styles.textSm}`}>
            <StringPreview
              value={profile.accomplishments || ''}
              name="Accomplishments"
              maxLen={200}
            />
          </p>
        </div>
      </section>
    </MobilePreview>
  );
};
